import { createSlice } from "@reduxjs/toolkit"
import { status_slices } from "../../Constants";

export const catalogs = createSlice({
    name: 'catalogs',
    initialState: {
        isLoading: true,
        status: status_slices.SUCCESS,
        msg: '',
        catalog: [],
        catalogEdit: [],
    },
    reducers: {
        setCatalog: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.catalog = action.payload.catalog;
            state.msg = action.payload.msg;
        },
        setCatalogEdit: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.catalogEdit = action.payload.catalogEdit;
            state.msg = action.payload.msg;
        },
        clearCatalog: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.catalog = [];
            state.msg = [];
        },
        clearCatalogEdit: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.catalogEdit = [];
            state.msg = [];
        },
        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = "";
            state.catalog = [];
            state.catalogEdit = [];
        },
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        }
    }
});

export const { processRequest, notProcessRequest, setCatalog, setCatalogEdit, clearCatalog, clearCatalogEdit,setError } = catalogs.actions;